import React, { PureComponent } from "react";

import Loader from "components/Loader/Loader.js";
import { Metric, Error, MiniMetric } from "components/Utils/Utils.js";
import Heading from "components/Elements/Heading";

class ChurnPayingSubsSummary extends PureComponent {
  render() {
    const { loading, data } = this.props;
    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }
    if (loading) {
      return <Loader minHeight={200} col={"col-12 col-md-6"} />;
    }

    return (
      <div className="row mt-2">
        <div className="col-7 mb-3 mb-sm-0">
          <Heading size={6} className={"mb-1"}>
            Total Subscribers
          </Heading>

          <div className="d-flex">
            <Metric {...data.metrics.total_subs} size={"lg"} />
          </div>

          <div className="d-flex justify-content-left align-items-center">
            <h6 className="mb-0 mr-2">Monthly</h6>
            <Metric {...data.metrics.total_subs_monthly} size={"xs"} />
          </div>
          <div className="d-flex justify-content-left align-items-center">
            <h6 className="mb-0 mr-2">Annual</h6>
            <Metric {...data.metrics.total_subs_annual} size={"xs"} />
          </div>
          <div className="d-flex justify-content-left align-items-center">
            <h6 className="mb-0 mr-2">Other</h6>
            <Metric {...data.metrics.total_subs_other} size={"xs"} />
          </div>
        </div>

        <div className="col-5 mb-3 mb-sm-0">
          <div
            className="d-flex justify-content-left align-items-center"
            style={{ marginTop: "14.4px" }}
          >
            <div className="d-flex flex-column ml-4 align-self-center">
              <MiniMetric {...data.metrics.total_subs_us} icon={"us"} />
              <MiniMetric {...data.metrics.total_subs_uk} icon={"gb"} />
              <MiniMetric {...data.metrics.total_subs_au} icon={"au"} />
              <MiniMetric
                {...data.metrics.total_subs_row}
                icon={"globe_europe_africa"}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ChurnPayingSubsSummary;
